import { useEffect } from 'react';

import AppRouter from './components/AppRouter';

import './App.css';
import { useAuth } from 'providers/auth-provider';
import { pushServerDataToGTM } from 'utilities/google-analytics';
import { getStatisticsSummary } from 'api/http-client/queries/statistics';
import { fetchProfile } from 'api/http-client/queries/profiles';
import { setProfile } from 'store/reducers/profileSlice';
import { useAppDispatch } from 'hooks';

function App() {
  const { isAuthorized } = useAuth();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const setGoogleAnalytics = async () => {
      if (!isAuthorized) {
        return;
      }

      const isServerDataPushed = sessionStorage.getItem("serverDataPushed") === 'true';
      if (isServerDataPushed) {
        return;
      }

      const stats = await getStatisticsSummary();
      if (stats !== null) {
        pushServerDataToGTM(stats);
      }
    }

    const getProfile = async () => {
      const {returned} = await fetchProfile();
      dispatch(setProfile(returned));
    }

    setGoogleAnalytics();
    getProfile();
  }, [isAuthorized]);

  return <AppRouter />;
}

export default App;
